import { render, staticRenderFns } from "./ProductClassesSelectModal.vue?vue&type=template&id=597c925c&scoped=true"
import script from "./ProductClassesSelectModal.vue?vue&type=script&lang=js"
export * from "./ProductClassesSelectModal.vue?vue&type=script&lang=js"
import style0 from "./ProductClassesSelectModal.vue?vue&type=style&index=0&id=597c925c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597c925c",
  null
  
)

export default component.exports